'use client'

import { Accordion, Divider, Text } from '@vinted/web-ui'

import { SeparatedList } from '@marketplace-web/shared/ui-helpers'
import { useTranslate } from '@marketplace-web/shared/i18n'
import { useSession } from '@marketplace-web/shared/session'

const TRANSLATION_PREFIX = 'business.homepage.faq'

const BusinessAccountsFaq = () => {
  const translate = useTranslate(TRANSLATION_PREFIX)
  const { user } = useSession()
  const isLoggedIn = !!user

  return (
    <SeparatedList separator={<Divider />}>
      <Accordion
        title={translate('is_free.title')}
        content={<Text as="span" text={translate('is_free.body')} html />}
        headerId="accordion_is_free_header"
        bodyId="accordion_is_free_body"
      />
      <Accordion
        title={translate('both_accounts.title')}
        content={<Text as="span" text={translate('both_accounts.body')} html />}
        headerId="accordion_both_accounts_header"
        bodyId="accordion_both_accounts_body"
      />
      {isLoggedIn ? (
        <Accordion
          title={translate('will_items_move.title')}
          content={<Text as="span" text={translate('will_items_move.body')} html />}
          headerId="accordion_will_items_move_header"
          bodyId="accordion_will_items_move_body"
        />
      ) : (
        <Accordion
          title={translate('what_policies.title')}
          content={<Text as="span" text={translate('what_policies.body')} html />}
          headerId="accordion_what_policies_header"
          bodyId="accordion_what_policies_body"
        />
      )}
      <Accordion
        title={translate('details_visibility.title')}
        content={<Text as="span" text={translate('details_visibility.body')} html />}
        headerId="accordion_details_visibility_header"
        bodyId="accordion_details_visibility_body"
      />
      <Accordion
        title={translate('what_sell.title')}
        content={<Text as="span" text={translate('what_sell.body')} html />}
        headerId="accordion_what_sell_header"
        bodyId="accordion_what_sellw_body"
      />
    </SeparatedList>
  )
}

export default BusinessAccountsFaq
